var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "form",
      staticClass: "pr-1 vertical-flex-fit",
      attrs: { id: "app-data-container" },
    },
    [
      _c("div", { staticClass: "h-100", attrs: { id: "application-form" } }, [
        _c("div", { attrs: { id: "forms" } }, [
          _vm.loading
            ? _c("div", [_c("forms-page-loader")], 1)
            : _c("div", { staticClass: "row no-gutters" }, [
                _vm.editing
                  ? _c("div", { staticClass: "section-wrapper w-100" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-end mb-3 pt-2 pr-2 sticky-top",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary mr-3",
                              attrs: { disabled: _vm.saving },
                              on: { click: _vm.handleFinishEdit },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-arrow-left mr-3",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("global.words.back")) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { disabled: _vm.saving },
                                on: { click: _vm.handleEditPrintForm },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-print mr-3",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("global.words.print")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "card-header" },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "section-separator-title d-inline-block mr-3",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.editingForm.fullName) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.saving
                              ? [
                                  _c("div", {
                                    staticClass:
                                      "ld ld-ring ld-spin-fast small-loader",
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _c("form-formulary", {
                              attrs: {
                                form: _vm.formToEdit,
                                "application-id": _vm.applicationId,
                                "client-username": _vm.clientUsername,
                              },
                              on: { saving: _vm.handleSaving },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "section-wrapper w-100" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end mb-3" },
                          [
                            _c(
                              "button",
                              {
                                ref: "printSelected",
                                staticClass: "btn btn-primary mr-3",
                                attrs: {
                                  disabled: !_vm.currentMortgages.length,
                                },
                                on: { click: _vm.handleClearAll },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("global.actions.clearAll")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _c(
                                "button",
                                {
                                  ref: "printSelected",
                                  staticClass: "btn btn-primary mr-3",
                                  on: { click: _vm.handleSelectAll },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("global.actions.selectAll")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                ref: "printSelected",
                                staticClass: "btn btn-primary",
                                attrs: { disabled: !_vm.canDownloadSelected },
                                on: { click: _vm.handlePrintSelected },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-pdf-forms.actions.printSelectedDocuments"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.printing
                          ? _c("div", [
                              _c("div", { staticClass: "card py-5" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row justify-content-center align-items-center w-100",
                                  },
                                  [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-12 text-center" },
                                      [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              "regular text-light-gray align-middle mt-3",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "application-pdf-forms.messages.weAreGeneratingYourForms"
                                                  )
                                                ) +
                                                "\n                    ...\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm.currentMortgages.length
                          ? _vm._l(
                              _vm.currentMortgages,
                              function (mortgageType) {
                                return _c(
                                  "div",
                                  {
                                    key: mortgageType,
                                    staticClass: "card mb-3",
                                  },
                                  [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "section-separator-title",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("application-form")[
                                                  mortgageType
                                                ]
                                              ) +
                                              "\n                  " +
                                              _vm._s(
                                                _vm.$t("global.doorr.mortgage")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "card-body" },
                                      [
                                        _c("forms-table", {
                                          attrs: {
                                            "mortgage-type": mortgageType,
                                            "document-forms": _vm.documentForms,
                                            "select-and-print-enabled":
                                              _vm.formSelectionEnabled,
                                          },
                                          on: {
                                            select: _vm.handleMarkForDownload,
                                            edit: _vm.handleEditForm,
                                            print: _vm.handlePrintForm,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          : [
                              _c("div", { staticClass: "card py-5" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row justify-content-center align-items-center",
                                  },
                                  [
                                    _c(
                                      "no-results",
                                      {
                                        attrs: {
                                          "img-src": require("@Shared/@Assets/img/application-missing.png"),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                "global.messages.youNeedToFillOutMortgageDetailsFirst"
                                              )
                                            ) +
                                            "\n                  ...\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                      ],
                      2
                    ),
              ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col text-center" }, [
      _c("div", { staticClass: "ld ld-ring ld-spin-fast" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }